import type { Technique } from '../types';
import { DELAUNAY_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type DelaunayState } from './render';

export const delaunay: Technique<DelaunayState> = {
  id: 'delaunay',
  name: 'Delaunay-Netz',
  category: 'packing',
  description: 'Dreiecksnetz über verteilte Punkte, mit Filter für die Kantenlänge.',
  params: DELAUNAY_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
